/**
 * @generated SignedSource<<fb21a3db5fad8b20f33ccc082fb70353>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "feedIds"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DisruptionInfoButtonContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QueryType",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "feedIds",
                "variableName": "feedIds"
              }
            ],
            "kind": "FragmentSpread",
            "name": "DisruptionInfoButton_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DisruptionInfoButtonContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "QueryType",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "feeds",
                "variableName": "feedIds"
              }
            ],
            "concreteType": "Alert",
            "kind": "LinkedField",
            "name": "alerts",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4aa0ccccb5a52bffa49c0488f6f531e9",
    "id": null,
    "metadata": {},
    "name": "DisruptionInfoButtonContainerQuery",
    "operationKind": "query",
    "text": "query DisruptionInfoButtonContainerQuery(\n  $feedIds: [String!]\n) {\n  viewer {\n    ...DisruptionInfoButton_viewer_333Ejr\n  }\n}\n\nfragment DisruptionInfoButton_viewer_333Ejr on QueryType {\n  alerts(feeds: $feedIds) {\n    id\n  }\n}\n"
  }
};
})();

node.hash = "60de331950f7e8226a84bdfe28acd297";

export default node;
